export const headersmp = {
    'Content-Type': 'multipart/form-data',
    'Authorization': window.localStorage.getItem("token")
};
